import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class QuickPostPrompt extends BaseOption {
  static userInterfaceComponent = {
    label: "Prompt above the box",
    component: inspectorTools.SIMPLE_INPUT,
  };

  static defaultValue = "";
}
